/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stock_Out_Shortage_TitleInputs */

const vi_stock_out_shortage_title = /** @type {(inputs: Stock_Out_Shortage_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kho không đủ hàng cho đơn này`)
};

/**

* @param {Stock_Out_Shortage_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stock_out_shortage_title = /** @type {((inputs?: Stock_Out_Shortage_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Out_Shortage_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stock_out_shortage_title(inputs)
});